export default function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/within.js
// module id = J32g
// module chunks = 0